function ghd_liveSearch( form ) {
  var searchTerm,
      newSeachTerm = form.find('input#search').val(),
      searchResults = form.find('.search-results'),
      searchResultsList = searchResults.find(' .frame');

  // search if value exists
  if ( newSeachTerm.length > 0 ) {
    // prevent ajax call if search term is the same
    if ( newSeachTerm === searchTerm ) {
      form.addClass('active');

      // call for search results
    } else {
      // update global search term
      searchTerm = newSeachTerm;

      form.addClass('active-search');
  
      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'ghd_search',
          searchTerm: searchTerm
        },
        success: function(data) {
          searchResultsList.empty().append(data);
          searchResults.height( searchResultsList.height() + 'px');
          form.addClass('active');
          form.removeClass('active-search');

          ga('create', 'UA-115042374-2', 'auto');
          ga('send', 'pageview', '/?s=' + searchTerm );

          searchResultsList.find('a').each(function() {
            $(this).on('click', function(e) {
              smoothState.load( $(this).attr('href') );
              e.preventDefault();
            });
          });
        }
      });
    }
  } else {
    form.removeClass('active');
  }
}



function init() {

  // Live search
  if ($(".search-form").length > 0) {
    $(".search-form").each(function() {
      var timer,
          timeout = 500,
          form = $(this);

      
      form
      .find('input#search')
      .on('keyup', function() {
        clearTimeout( timer );
        timer = setTimeout( ghd_liveSearch( form ), timeout );
      })
      .on('focus', function() {
        clearTimeout( timer );
        timer = setTimeout( ghd_liveSearch( form ), 0 );
      })
      .on('keydown', function() {
        clearTimeout( timer );
      })
      .keypress(function(e) {
        if (e.which == 13) {
          form.find('form').submit();
        }
      });

      form.on('click', function(e) {
        e.stopPropagation();
      });

      // Close if clicked outside
      $(document).on('click', function(e) {
        form.removeClass('active');
      });
    });
  }

}

module.exports = { init };